import { LoadingOutlined } from "@ant-design/icons";
import type { ReactNode } from "react";
import { ErrorProvider } from "~components/ErrorHandler/ErrorProvider.tsx";
import { useUserPermissions } from "~context/UserPermissionsContext";
import { type PermissionNames, PermissionOperations } from "~enums/permissions.ts";
import { AccessDeniedPage } from "~pages/ErrorPages";

interface AuthGuardProps {
  children: ReactNode;
  permissionKeys: Array<PermissionNames>;
}

const AuthGuard = ({ children, permissionKeys }: AuthGuardProps) => {
  const { isLoadingPermissions, hasOrganizationAccess, hasAnyPermission } = useUserPermissions();

  if (isLoadingPermissions) {
    return (
      <div className="loading-full-screen">
        <LoadingOutlined style={{ fontSize: 44 }} spin />
      </div>
    );
  }

  const permissionConfig = permissionKeys.map((permissionName) => ({ permissionName, permissionOperations: [PermissionOperations.READ] }));

  if (hasOrganizationAccess && (permissionKeys.length === 0 || hasAnyPermission(permissionConfig))) {
    return <ErrorProvider>{children}</ErrorProvider>;
  }
  return <AccessDeniedPage />;
};

export default AuthGuard;
